import React, { Component } from "react";
import Parse from "parse";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Header from "../Header/header";
import HeaderContainer from "../Header/LandingHeader/HeaderContainer";
import Footer from "../Footer/footer";
import { Contentstyled, Layoutstyled } from "../Constants/style";
import { getAvatar } from "../Constants/functions";

import { Card, Col, List, Row, Popover, Spin } from "antd";
const moment = require("moment-timezone");
moment.locale("fr");
Parse.initialize("6cev9RMB5Q36eXubFhT27zEzDJ9ZfCDDBJv87csPPYE62tAvKD");

const Cardstyled = styled(Card)`
  .ant-card-body {
    padding: 0px;
  }
`;

class Team extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      members: [],
      visible: false
    };
  }

  async componentDidMount() {
    this.currentUser = await Parse.User.current().fetch();
    if (this.currentUser.attributes.team) {
      this.queryBestTeam();
      this.team = await this.currentUser.attributes.team.fetch();

      if (this.team !== undefined) {
        //console.log('team : ', this.currentUser.attributes.team)
        let teamMates = await Parse.Cloud.run("getMembers");
        var json = JSON.stringify(teamMates);
        var jsonMembers = JSON.parse(json);
        this.members = jsonMembers;
        //console.log("members: ", this.members);
        if (this.team.attributes.coach !== undefined) {
          let coachQuery = new Parse.Query(Parse.User);
          coachQuery.equalTo("objectId", this.team.attributes.coach.id);
          let coach = await coachQuery.find();
          let json = JSON.stringify(coach);
          this.coach = JSON.parse(json);
          //console.log("coach : ", this.coach);
        }
        if (this.team.attributes.diet !== undefined) {
          let dietQuery = new Parse.Query(Parse.User);
          dietQuery.equalTo("objectId", this.team.attributes.diet.id);
          let coach = await dietQuery.find();
          let json = JSON.stringify(coach);
          this.diet = JSON.parse(json);
          //console.log("diet : ", this.diet);
        }
        this.setState({ loading: false });
      }
    } else {
      // we set it to false
      this.setState({ loading: false });
    }
  }

  queryBestTeam = async () => {
    let teamId = this.currentUser.get('team').id
    let query = new Parse.Query("Team");
    query.addDescending("ptsFidelity");
    this.teams = await query.find();
    this.ranking = this.teams.findIndex(item => item.id === teamId) + 1
    this.classement = `${this.ranking} / ${this.teams.length} équipes`
  }

  showModal = () => {
    this.setState({
      visible: true
    });
  };

  handleCancel = e => {
    this.setState({
      visible: false,
      pro: "",
      nonpro: ""
    });
  };

  //display the members

  //faire display members pour les pros et accéder au profil.

  displayMembers(members) {
    members = members.filter(
      item => item.hasOwnProperty("nickName") && item.hasOwnProperty("avatar")
    );
    //si l'utilisateur est un professionnel de la team, il peut accéder au détail des clients
    if (this.currentUser.attributes.professional === true) {
      //filter for undefined values
      return (
        <List
          dataSource={members}
          grid={{ xl: 2 }}
          locale={{ emptyText: "Il n'y a personne à montrer ici" }}
          renderItem={item => (
            <Link
              to={{
                pathname: `/client/${item.objectId}`,
                state: { id: item.objectId }
              }}
            >
              <List.Item>

                <Popover
                  content={
                    <div>
                      <p>
                        {item.firstName} {item.lastName}{" "}
                      </p>
                      <p>{item.desc}</p>
                      <span style={{ fontSize: "12px", fontStyle: "italic" }}>
                      membre depuis le{" "}
                        {moment(item.createdAt).format("DD/MM/YYYY")}
                      </span>
                    </div>
                  }
                >
                  <Cardstyled
                    hoverable
                    style={{
                      width: "250px",
                      display: "block",
                      margin: "15px auto"
                    }}
                  >
                    <div style={{ padding: "0" }}>

                      <img
                        style={{ width: "250px", height: "250px" }}
                        src={getAvatar(item)}
                        alt="avatar"
                      />
                    </div>
                  </Cardstyled>
                </Popover>
              </List.Item>
            </Link>
          )}
        />
      );
    } else {
      return (
        <List
          dataSource={members}
          grid={{ xl: 2 }}
          locale={{ emptyText: "Il n'y a personne à montrer ici" }}
          renderItem={item => (
            <List.Item>
              <Popover
                content={
                  <div>
                    <p>
                      {item.firstName} {item.lastName}{" "}
                    </p>
                    <p>{item.desc}</p>
                    <span style={{ fontSize: "12px", fontStyle: "italic" }}>
                      membre depuis le{" "}
                      {moment(item.createdAt).format("DD/MM/YYYY")}
                    </span>
                  </div>
                }
              >
                <Cardstyled
                  hoverable
                  style={{
                    width: "250px",
                    display: "block",
                    margin: "15px auto"
                  }}
                >
                  <div style={{ padding: "0" }}>
                    <img
                      style={{ width: "250px", height: "250px" }}
                      src={getAvatar(item)}
                      alt="avatar"
                    />
                  </div>
                </Cardstyled>
              </Popover>
            </List.Item>
          )}
        />
      );
    }
  }

  render() {
    if (this.state.loading === true) {
      return (
        <Layoutstyled>
          <Header />
          <HeaderContainer />
          <Contentstyled>
            <Row
              style={{ marginTop: "200px" }}
              type="flex"
              justify="center"
              align="middle"
            >
              <Spin size="large" />
            </Row>
          </Contentstyled>
          <Footer />
        </Layoutstyled>
      );
    }

    if (this.currentUser.attributes.team === undefined) {
      return (
        <Layoutstyled>
          <Header />
          <HeaderContainer />
          <Contentstyled>
            <h4 style={{ textAlign: "center", marginTop: "15%" }}>
              {`Vous n'êtes pas encore dans une Team ! Veuillez attendre qu'un administrateur vous en attribue une. `}
            </h4>
          </Contentstyled>
          <Footer />
        </Layoutstyled>
      );
    }
    let diet = this.diet === undefined ? [] : this.diet;
    let coach = this.coach === undefined ? [] : this.coach;

    return (
      <Layoutstyled>
        <Header />
        <HeaderContainer />
        <Contentstyled>
        <Row
          type="flex"
          justify="center"
          align="top"
          style={{ width: "100%" }}>
          <p
            style={{
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "18px",
              color: "#0000FE"
            }}
          >  Bienvenue sur la Team {this.team.attributes.nickName} !
          </p>
          </Row>
          <Row>
          <p style={{
            textAlign: "center",
            fontSize: "16px"
          }}>
          Nombre de points : {this.team.attributes.ptsFidelity} </p>

        </Row>
        <Row type="flex"
        justify="center">
        <span style={{
          textAlign: "center",
          fontSize: "16px",
          backgroundColor: "#0000FE",
          color: "white"
        }}>
        Classement Best Team : {this.classement} </span>

      </Row>
          <Row
            type="flex"
            justify="center"
            align="top"
            style={{ width: "100%", marginTop: "20px" }}
          >
            <Col xs={24} sm={24} md={24} lg={10} xl={10}>
              <p
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "18px",
                  color: "#0000FE"
                }}
              >
                Les URBANS FITTEURS
              </p>
              {this.displayMembers(this.members)}
            </Col>
            <Col xs={24} sm={24} md={24} lg={7} xl={7}>
              <Row type="flex" justify="center" align="middle">
                <Col>
                  <p
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "18px",
                      color: "#0000FE"
                    }}
                  >
                    Le Coach
                  </p>
                  {this.displayMembers(coach)}
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={24} md={24} lg={7} xl={7}>
              <Row type="flex" justify="center" align="middle">
                <Col>
                  <p
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "18px",
                      color: "#0000FE"
                    }}
                  >
                    Le Diététicien
                  </p>
                  {this.displayMembers(diet)}{" "}
                </Col>
              </Row>
            </Col>
          </Row>
        </Contentstyled>
        <Footer />
      </Layoutstyled>
    );
  }
}

const mapStatetoProps = globalReducers => globalReducers;

const connectedTeam = connect(mapStatetoProps)(Team);
export default connectedTeam;
